"use client"

import { Button } from "@/components/ui/button"
import { UserPlus } from "lucide-react"

interface MobileSignUpCTAProps {
  ctaText: string
  onCtaClick: () => void
  isVisible: boolean
}

export function MobileSignUpCTA({ ctaText, onCtaClick, isVisible }: MobileSignUpCTAProps) {
  if (!isVisible) return null

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 lg:hidden bg-background/95 backdrop-blur-xl border-t border-white/[0.06] p-4 pb-[calc(1rem+env(safe-area-inset-bottom))]">
      <Button
        onClick={onCtaClick}
        className="w-full h-12 bg-[#CC3E21] hover:bg-[#b5351b] text-white font-bold text-base rounded-xl gap-2"
      >
        <UserPlus className="h-4 w-4" />
        {ctaText}
      </Button>
    </div>
  )
}
